import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { LogOut, Rows3, Settings, UserRound } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { toast } from "sonner";
import { useEffect, useState } from "react";
import { logout, getCurrentUserEmail } from "@/lib/auth";
import { useDensity } from "@/hooks/useDensity";

export function UserMenu() {
  const navigate = useNavigate();
  const [mounted, setMounted] = useState(false);
  const { density, setDensity } = useDensity();

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  const email = getCurrentUserEmail();

  const handleLogout = () => {
    toast.success("Logged out successfully");
    logout();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="relative h-10 w-10 p-0 rounded-full">
          <Avatar className="h-8 w-8">
            <AvatarImage
              src={`https://api.dicebear.com/7.x/lorelei/svg?seed=${email || "default"}`}
              alt="User avatar"
            />
            <AvatarFallback>
              <UserRound className="h-4 w-4" />
            </AvatarFallback>
          </Avatar>
          <span className="sr-only">User menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        {email && (
          <>
            <DropdownMenuLabel className="font-normal">
              <p className="text-sm font-medium truncate">{email}</p>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
          </>
        )}
        <DropdownMenuLabel className="text-xs font-normal text-muted-foreground">
          <Rows3 className="mr-2 inline h-3.5 w-3.5" />
          Density
        </DropdownMenuLabel>
        <DropdownMenuCheckboxItem
          checked={density === "comfortable"}
          onCheckedChange={() => setDensity("comfortable")}
        >
          Comfortable
        </DropdownMenuCheckboxItem>
        <DropdownMenuCheckboxItem
          checked={density === "compact"}
          onCheckedChange={() => setDensity("compact")}
        >
          Compact
        </DropdownMenuCheckboxItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate("/system/tenant")}>
          <Settings className="mr-2 h-4 w-4" />
          <span>Settings</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleLogout}>
          <LogOut className="mr-2 h-4 w-4" />
          <span>Log out</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
